/**
 * Resolve display title for a mission/supplication week document.
 * Prefers localizedContent, then legacy pt nesting, then top-level title.
 */
export function getWeekTitle(week, languageCode = 'en') {
  if (!week) return ''
  if (languageCode === 'pt' && week.pt && week.pt.title) {
    return week.pt.title
  }
  if (week.localizedContent && week.localizedContent[languageCode]) {
    const lcTitle = week.localizedContent[languageCode].title
    if (lcTitle && lcTitle.trim()) return lcTitle
  }
  return week.title || ''
}
